class VariantDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');
    this.drawerMenu = document.querySelector('#' + this.mainDetailsToggle.dataset.drawer);
    document.querySelector('.variant-drawer__overlay').addEventListener('click', this.onCloseButtonClick.bind(this));

    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );
    this.drawerMenu
      .querySelectorAll('.variant-drawer__close')
      .forEach((button) => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
    this.drawerMenu
      .querySelectorAll('.variant-drawer__discard')
      .forEach((button) => button.addEventListener('click', this.onResetButtonClick.bind(this)));
    this.drawerMenu.querySelectorAll('input').forEach((radio) => {
      radio.addEventListener('click', () => this.onRadioButtonClick(radio.value));
    });
  }

  onSummaryClick(event) {
    const detailsElement = event.currentTarget.parentNode;
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      trapFocus(event.currentTarget.nextElementSibling, detailsElement.querySelector('button'));
      event.currentTarget.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (detailsElement.hasAttribute('open')) {
        event.preventDefault();
        this.closeMenuDrawer(event, event.currentTarget);
      } else {
        this.openMenuDrawer(event.currentTarget);
      }

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        event.currentTarget.setAttribute('aria-expanded', true);
        detailsElement.closest('.has-submenu')?.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : event.currentTarget.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    this.drawerMenu.setAttribute('open', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });
    this.drawerMenu.removeAttribute('open');

    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
  }

  onCloseButtonClick(event) {
    this.closeMenuDrawer(event, this.mainDetailsToggle);
  }

  onResetButtonClick(event) {
    this.drawerMenu.querySelector('.variant-drawer__radio input').click();
  }

  onRadioButtonClick(val) {
    this.mainDetailsToggle.querySelector('h2').innerText = val;
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('variant-drawer', VariantDrawer);
